import i18n from 'localization';
import { ERROR_TYPE } from '#shared/types/common';
import { ROUTES } from './routes';

export const notFoundErrorProps = {
  message: i18n.t('errors:notFound.message'),
  componentProps: {
    title: '404',
    description: i18n.t('errors:notFound.description'),
  },
};

export const defaultCriticalErrorProps = {
  type: ERROR_TYPE.CRITICAL,
  isSystemError: true,
  componentProps: {
    hasRefreshBtn: true,
  },
};

export const defaultNotificationErrorProps = {
  message: i18n.t('errors:notification.default.message'),
  type: ERROR_TYPE.NOTIFICATION,
  componentProps: {
    title: i18n.t('errors:notification.default.title'),
  },
};

export const tryAgainNotificationErrorProps = {
  type: ERROR_TYPE.NOTIFICATION,
  message: i18n.t('errors:notification.tryAgain.message'),
  componentProps: {
    title: i18n.t('errors:notification.default.title'),
  },
};

export const conflictNotificationErrorProps = {
  type: ERROR_TYPE.NOTIFICATION,
  message: i18n.t('errors:notification.conflict.message'),
};

export const permissionNotificationErrorProps = {
  type: ERROR_TYPE.NOTIFICATION,
  message: i18n.t('errors:notification.permission.message'),
};

export const taskSuspendedErrorProps = {
  message: i18n.t('pages:task.errors.taskSuspended.message'),
  isSystemError: true,
  componentProps: {
    description: i18n.t('pages:task.errors.taskSuspended.description'),
    backLink: ROUTES.PROCESS_INSTANCE_LIST,
    backLinkTitle: i18n.t('pages:task.errors.taskSuspended.backLinkTitle'),
  },
};

export const formNotFoundErrorProps = {
  message: i18n.t('pages:task.errors.formNotFound.message'),
  isSystemError: true,
  componentProps: {
    description: i18n.t('pages:task.errors.formNotFound.description'),
    backLink: ROUTES.PROCESS_INSTANCE_LIST,
    backLinkTitle: i18n.t('pages:task.errors.formNotFound.backLinkTitle'),
  },
};

export const forbiddenErrorProps = {
  message: i18n.t('errors:forbidden.message'),
  isSystemError: true,
  componentProps: {
    title: '403',
    description: i18n.t('errors:forbidden.description'),
    backLinkTitle: i18n.t('errors:forbidden.backToStart'),
    backLink: `${ROUTES.LOGOUT}`,
  },
};

export const processDefinitionFormNotFoundErrorProps = {
  message: i18n.t('pages:startForm.errors.formNotFound.message'),
  isSystemError: true,
  componentProps: {
    description: i18n.t('pages:startForm.errors.formNotFound.description'),
    backLink: ROUTES.PROCESS_LIST,
    backLinkTitle: i18n.t('pages:startForm.errors.formNotFound.backLinkTitle'),
  },
};

export const processDefinitionNotFoundErrorProps = {
  message: i18n.t('pages:startForm.errors.processNotFound.message'),
  isSystemError: true,
  componentProps: {
    description: i18n.t('pages:startForm.errors.processNotFound.description'),
    backLink: ROUTES.PROCESS_LIST,
    backLinkTitle: i18n.t('pages:startForm.errors.processNotFound.backLinkTitle'),
  },
};

export const rateLimitCriticalErrorProps = {
  type: ERROR_TYPE.CRITICAL,
  componentProps: {
    description: i18n.t('errors:rateLimit.description'),
    hasRefreshBtn: true,
    hideNavigation: true,
  },
};
